module.exports = ".box {\n  width: 250px;\n  height: 200px;\n  top: 40;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  margin: auto; }\n"